import { Component, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { ResponseStatus } from '../common/Interfaces';
import { DataServiceEntity } from '../data-services/data-service.entity';
import { DisplayErrors } from './errors-sidenav';
import { LoggingService } from './services/logging/logging.service';

const log = new LoggingService();
export type CloneIndex = string | number;

@Component({
    template: '',
    standalone: false
})
export class EditGrid<T extends DataServiceEntity<T>>
    extends DisplayErrors<T>
    implements OnChanges
{
    public editing?: T = undefined;
    selected: any = null; // (T | undefined)[] | T;
    cloned: { [i in CloneIndex]: T } = {};
    private savedItem: T;
    @Output() SelectItem = new ReplaySubject<T | T[]>(1);
    @Output() SaveItem = new ReplaySubject<T | T[]>(1);
    @Output() DeleteItem = new ReplaySubject<T | T[]>(1);
    @Output() CancelItem = new ReplaySubject<T | T[]>(1);
    @Output() EditItem = new ReplaySubject<T>(1);
    onRowEditInit(item: T) {
        log.verbose({ type: `EditGrid<${typeof this}>:onRowEditInit`, item });
        this.selected = [item];
        this.onRowSelect({ data: item });
        this.cloned[item.id] = { ...item };
        this.editing = item;
        this.EditItem.next(item);
    }
    onRowEditCancel(item: T) {
        log.verbose({
            type: `EditGrid<${typeof this}>:onRowEditCancel`,
            item
        });
        let index = this.items.findIndex(x => x.id === item.id);

        if (index >= 0) {
            this.items.splice(index, 1, this.cloned[item.id]);
        }
        index = this.items.findIndex(x => x.id === 'add');
        if (index >= 0) {
            this.items.splice(index, 1);
        }
        this.items = [...this.items];
        this.selected = [];

        delete this.cloned[item.id];
        delete this.editing;
        this.CancelItem.next(item);
    }
    onRowEditSave(item: T) {
        log.verbose({
            type: `EditGrid<${typeof this}>:onRowEditSave`,
            item
        });
        item.Status = item.Status || { StatusCode: 0, Message: '' };
        item.Status.StatusCode = ResponseStatus.Loading;
        item.Status.Message = 'Saving';
        if ((item.isValid && item.isValid()) || !item.isValid) {
            this.SaveItem.next([item]);
            delete this.cloned[item.id];
            delete this.editing;
        } else {
            item.Status.StatusCode = ResponseStatus.Error;
            item.Status.Message = 'Invalid';
        }
    }
    onRowSelect($event) {
        log.verbose({
            type: `EditGrid<${typeof this}>:onRowSelect`,
            $event,
            editing: this.editing,
            selected: this.selected
        });
        if (this.editing) {
            setTimeout(() => {
                this.selected = [this.editing];
            }, 0);
        } else {
            this.SelectItem.next($event.data);
        }
    }
    onRowEditDelete(item: T, index: number) {
        this.items.splice(index, 1, this.cloned[item.id]);

        this.DeleteItem.next([item]);

        delete this.cloned[item.id];
        delete this.editing;
        return;
    }
    ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
        if (changes && changes.items) {
            if (this.savedItem) {
                const idx = this.items.findIndex(
                    item => item.id.toString() === this.savedItem.id.toString()
                );
                this.dataTable.scrollToVirtualIndex(idx);
            }
        }
    }
    trackById = (item: T) => item.id;
}
